import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
// axios.defaults.baseURL = 'http://localhost/efback/public/';
// for prod settings
// axios.defaults.baseURL = 'https://restapi.excelfinance.mn/';
axios.defaults.baseURL = 'http://103.153.141.100:8081/';


export default new Vuex.Store({
	state: {
  		status: '',
  		token: sessionStorage.getItem('token') || '',
  		user : {},
	},
	mutations: {
		auth_request(state){
	    	state.status = 'loading'
	  	},
	  	auth_success(state, token, user){
		    state.status = 'success'
		    state.token = token
		    state.user = user
	  	},
	  	auth_error(state){
	    	state.status = 'error'
	  	},
	  	logout(state){
	    	state.status = ''
	    	state.token = ''
			state.user = {}
	  	},
	},
	actions: {
	  	login({commit}, user){
	        return new Promise((resolve, reject) => {
	            commit('auth_request')
	            axios({url: 'login_admin', data: user, method: 'POST' })
	            .then(resp => {
					console.log(resp)
	                const token = resp.data.access_token
	                const user = resp.data.user
	                sessionStorage.setItem('token', token)
					sessionStorage.setItem('user', JSON.stringify(user))
	                // Add the following line:
	                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
	                commit('auth_success', token, user)
	                resolve(resp)
	            })
	            .catch(err => {
	                commit('auth_error')
	             	sessionStorage.clear()
	                reject(err)
	            })
	        })
	    },
	    register({commit}, user){
	    	return new Promise((resolve, reject) => {
	            commit('auth_request')
	            axios({url: 'register', data: user, method: 'POST' })
	            .then(resp => {
					console.log(resp)
	                const token = resp.data.access_token
	                const user = resp.data.user
	                sessionStorage.setItem('token', token)
	                // Add the following line:
	                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
	                commit('auth_success', token, user)
	                resolve(resp)
	            })
	            .catch(err => {
	                commit('auth_error', err)
	                sessionStorage.removeItem('token')
	                reject(err)
	            })
	        })
	    },
	  	logout({commit}){
		    return new Promise((resolve, reject) => {
		      	commit('logout')
				sessionStorage.clear()
		      	delete axios.defaults.headers.common['Authorization']
		      	resolve()
		    })
	  	},
	},
	getters : {
	  isLoggedIn: state => !!state.token,
	  authStatus: state => state.status,
	  uInfo: state => state.user,
	}
})